import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopunecabs() {



  const cardData =
  {
    keyword: 'Mumbai to Pune Cab',
    heading: 'Shambhu Cabs: Mumbai to Pune Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Pune Cab services, providing safe, comfortable, and hassle-free travel for daily commuters, business travelers, families, and weekend trippers. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and convenient journey from Mumbai to Pune with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking assistance, Shambhu Cabs makes intercity travel quick, stress-free, and affordable. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Pune cab services for travelers seeking comfort, punctuality, and reliability throughout the journey.',

    top: 'Top Places to Visit in Pune with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is one of Pune’s most iconic historical landmarks. Known for its massive fortification walls, grand gateways, and the legendary story of Bajirao I, the fort still echoes Maratha history. The evening light-and-sound show beautifully narrates Pune’s rich heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant monument of India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace features a museum, sprawling gardens, Italian arches, and memorials, offering peace and historical insight."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "One of Pune’s most famous temples, the Dagdusheth Ganpati Temple is known for its magnificent idol adorned with gold and ornaments. It is a major spiritual center attracting thousands daily. During Ganesh Chaturthi, the temple becomes the heart of grand cultural celebrations."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular trekking and historical site known for the 1670 Battle of Sinhagad led by Tanaji Malusare. With panoramic views of the Sahyadris, ancient fort walls, and local food stalls offering pithla-bhakri, it is Pune’s favorite getaway for history, nature, and adventure."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "This 8th-century rock-cut cave temple dedicated to Lord Shiva is carved from a single basalt rock. With its monolithic pillars, serene ambience, and ancient carvings, Pataleshwar offers a peaceful spiritual retreat amid Pune’s busy city life."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The museum showcases over 20,000 artifacts collected by Dr. Dinkar Kelkar, including musical instruments, sculptures, ornaments, and everyday antiques. The recreated Mastani Mahal is a major highlight, making it a must-visit for art and history lovers."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "One of the oldest heritage sites in Pune, Parvati Hill offers stunning city views after climbing 103 steps. The hilltop temple complex, built by the Peshwas, includes shrines of Shiva, Parvati, and other deities, making it both a spiritual and scenic attraction."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, this global meditation center is known for its peaceful gardens, meditation halls, and wellness programs. Visitors from around the world come to experience mindfulness, healing therapies, and inner peace in a serene setting."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this is Pune’s largest landscaped garden, featuring ponds, bridges, walking paths, and lush greenery. It is a beautiful spot for photography, relaxation, and peaceful evening strolls."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular spot for picnics and sunset views, Khadakwasla Dam offers scenic waterscapes and surrounding hills. It is also the gateway to Sinhagad Fort. Local food stalls and cool breezes make it a perfect weekend destination."
  }
],


 "services": [
  {
    "name": "Mumbai Pune Taxi Service",
    "description": "Mumbai Pune Taxi Service provides safe, comfortable, and reliable intercity travel between Mumbai and Pune. Ideal for business travelers, families, and tourists, this service offers well-maintained vehicles, professional drivers with knowledge of all major routes, and flexible pickup and drop options. Passengers can enjoy a hassle-free journey with timely arrivals, scenic highway rides, and multiple vehicle choices including sedans, SUVs, and luxury cabs."
  },
  {
    "name": "Mumbai Pune One-Way Cab",
    "description": "Mumbai Pune One-Way Cab is perfect for travelers who need single-direction travel without return charges. This service is ideal for airport transfers, corporate trips, and personal travel. With experienced chauffeurs, clean vehicles, and transparent pricing, passengers enjoy a stress-free and comfortable journey along the Mumbai–Pune expressway, with convenient door-to-door service and timely arrivals."
  },
  {
    "name": "Intercity Cab Mumbai Pune",
    "description": "Intercity Cab Mumbai Pune provides efficient, safe, and comfortable long-distance travel for daily commuters, tourists, and corporate travelers. Offering a variety of vehicles including sedans, SUVs, and premium cars, the service ensures professional drivers, on-time pickups, smooth highway navigation, and a relaxing travel experience. Perfect for weekend trips, business meetings, or family travel."
  },
  {
    "name": "Mumbai to Pune Car Rental",
    "description": "Mumbai to Pune Car Rental offers flexible, affordable, and convenient car hire options for intercity travel. Customers can choose from a wide range of vehicles with professional chauffeurs for a comfortable, safe, and stress-free journey. The service allows door-to-door pickup and drop, customized travel schedules, and multiple vehicle options for solo travelers, families, or corporate clients."
  },
  {
    "name": "Best Cab Mumbai Pune",
    "description": "Best Cab Mumbai Pune is known for its premium fleet, punctual service, and customer satisfaction. The service provides well-maintained vehicles with air conditioning, spacious interiors, and experienced chauffeurs trained for long-distance highway driving. Ideal for corporate travelers, families, and tourists, this cab service ensures a safe, smooth, and enjoyable journey between Mumbai and Pune."
  },
  {
    "name": "Affordable Mumbai Pune Taxi",
    "description": "Affordable Mumbai Pune Taxi provides budget-friendly intercity travel without compromising comfort or safety. Passengers can enjoy transparent fare options, well-maintained vehicles, and professional drivers. The service is perfect for students, families, and daily commuters who require reliable, economical, and convenient travel between Mumbai and Pune."
  },
  {
    "name": "Mumbai Pune Airport Transfer",
    "description": "Mumbai Pune Airport Transfer offers seamless pick-up and drop services for travelers heading to or from Pune and Mumbai airports. With trained chauffeurs, clean vehicles, and on-time service, passengers experience a stress-free airport journey. Ideal for business trips, early flights, or connecting intercity travel, this service ensures timely arrivals, comfort, and safety."
  },
  {
    "name": "Chauffeur Service Mumbai Pune",
    "description": "Chauffeur Service Mumbai Pune provides a premium, professional driving experience for long-distance travel. Perfect for corporate travelers and VIP clients, the service features experienced drivers who ensure timely pickups, smooth rides, highway safety, and customer convenience. Passengers can relax and focus on work or leisure while the chauffeur manages the route efficiently."
  },
  {
    "name": "Sedan Cab Mumbai Pune",
    "description": "Sedan Cab Mumbai Pune offers a comfortable, economical, and smooth travel experience for solo travelers, couples, and small families. The vehicles are well-maintained, air-conditioned, and driven by professional chauffeurs trained for intercity travel. This service ensures timely pickups, safe highway travel, and a stress-free journey between Mumbai and Pune."
  },
  {
    "name": "SUV Cab Mumbai Pune",
    "description": "SUV Cab Mumbai Pune is ideal for families, groups, or travelers with extra luggage. Spacious and comfortable, these SUVs provide a luxurious and safe long-distance travel experience. Equipped with modern amenities, highway-ready features, and professional drivers, passengers can enjoy a smooth, reliable, and enjoyable journey between Mumbai and Pune."
  },
  {
    "name": "Expressway Cab Mumbai Pune",
    "description": "Expressway Cab Mumbai Pune specializes in fast, reliable, and comfortable travel along the Mumbai–Pune expressway. With professional drivers experienced in highway driving, well-maintained vehicles, and timely pick-ups, passengers experience a smooth and safe ride. Perfect for business travelers, tourists, and families seeking quick and hassle-free travel between the two cities."
  },
  {
    "name": "24×7 Mumbai Pune Cab",
    "description": "24×7 Mumbai Pune Cab provides round-the-clock intercity taxi services, accommodating early morning, late-night, or emergency travel needs. The service ensures reliable pickups, professional chauffeurs, clean vehicles, and safe highway journeys. Ideal for business travelers, urgent trips, or last-minute plans, passengers can travel between Mumbai and Pune any time of day or night."
  },
  {
    "name": "Mumbai Pune Outstation Cab",
    "description": "Mumbai Pune Outstation Cab offers convenient, safe, and comfortable transportation for travelers venturing between Mumbai and Pune. With multiple vehicle options, professional drivers, and flexible booking schedules, this service caters to families, tourists, and corporate clients. Passengers benefit from timely pickups, highway comfort, and a hassle-free intercity travel experience."
  },
  {
    "name": "Mumbai Pune Corporate Taxi",
    "description": "Mumbai Pune Corporate Taxi is designed for business travelers, executives, and corporate teams. The service provides premium vehicles, punctual pickups, professional drivers, and comfortable seating. Ideal for client meetings, office transfers, and corporate events, passengers enjoy reliable, safe, and stress-free intercity transportation between Mumbai and Pune."
  },
  {
    "name": "Fastest Cab Mumbai Pune",
    "description": "Fastest Cab Mumbai Pune focuses on quick, safe, and timely travel for passengers with tight schedules. Experienced chauffeurs navigate traffic efficiently, ensuring on-time arrivals and smooth highway travel. Ideal for business trips, urgent meetings, and early morning or late-night travel, this service guarantees reliable and efficient intercity transport."
  },
  {
    "name": "Mumbai to Pune Family Cab",
    "description": "Mumbai to Pune Family Cab caters specifically to families traveling together, offering spacious and comfortable vehicles. Equipped with modern amenities and driven by courteous and experienced chauffeurs, passengers can enjoy a safe and relaxed journey. Perfect for weekend getaways, family vacations, and group trips between Mumbai and Pune."
  },
  {
    "name": "Premium Mumbai Pune Cab",
    "description": "Premium Mumbai Pune Cab delivers a luxury travel experience with high-end vehicles, executive sedans, and chauffeur-driven SUVs. Focused on corporate clients, VIP travelers, and those seeking comfort, the service offers privacy, safety, punctuality, and a smooth intercity journey along the Mumbai–Pune corridor."
  },
  {
    "name": "Safe Taxi Mumbai Pune",
    "description": "Safe Taxi Mumbai Pune prioritizes passenger safety, comfort, and reliability. Vehicles are sanitized, fully maintained, and driven by trained chauffeurs with highway experience. This service ensures a secure, smooth, and stress-free journey for families, solo travelers, and corporate clients traveling between Mumbai and Pune."
  }
],

"tableData": [
  ["Mumbai Pune Taxi Service", "Mumbai Pune One-Way Cab"],
  ["Intercity Cab Mumbai Pune", "Mumbai to Pune Car Rental"],
  ["Best Cab Mumbai Pune", "Affordable Mumbai Pune Taxi"],
  ["Mumbai Pune Airport Transfer", "Chauffeur Service Mumbai Pune"],
  ["Sedan Cab Mumbai Pune", "SUV Cab Mumbai Pune"],
  ["Expressway Cab Mumbai Pune", "24×7 Mumbai Pune Cab"],
  ["Mumbai Pune Outstation Cab", "Mumbai Pune Corporate Taxi"],
  ["Fastest Cab Mumbai Pune", "Mumbai to Pune Family Cab"],
  ["Premium Mumbai Pune Cab", "Safe Taxi Mumbai Pune"]
],



"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Pune Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Pune cab services, ideal for business trips, airport transfers, family travel, and quick intercity journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and well-maintained cabs designed to provide a smooth and comfortable journey between Mumbai and Pune."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Expressway Routes",
    "WhyChoosedescription": "Our professional drivers are experienced with the Mumbai–Pune Expressway, ensuring a safe, fast, and stress-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Pune cab trip worry-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, travel queries, and real-time assistance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Intercity Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental packages tailored to your Mumbai to Pune travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every cab is thoroughly cleaned and sanitized to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and comfortable service, making your Mumbai to Pune journey smooth and hassle-free."
  }
]


















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Pune cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Pune cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Pune cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Pune cab bookings?',
    answer: 'Shambhu Cabs offers a fleet of well-maintained sedans, SUVs, and luxury cars suitable for travel between Mumbai and Pune.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Pune route?',
    answer: 'Yes, our drivers are licensed, professional, and well-versed with the Mumbai to Pune route to ensure a safe and smooth journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Pune cab?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off location anywhere in Pune.',
  },
  {
    question: 'Is the Mumbai to Pune cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Pune cab booking services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Pune cab bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers adhere to strict safety and hygiene protocols to ensure passenger safety.',
  },
  {
    question: 'What payment options are available for Mumbai to Pune cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Pune journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Pune travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aniket Patil',
    feedback: 'Our Mumbai to Pune trip with Shambhu Cabs was smooth and on time. The driver was polite and the car was very clean. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Swati Gokhale',
    feedback: 'Excellent Mumbai to Pune cab service by Shambhu Cabs. Professional driver and hassle-free booking experience.',
    rating: 5,
  },
];










































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-pune-cab.jpg",
  "description": "Shambhu Cabs provides fast, safe, and affordable Mumbai to Pune cab services with professional drivers and clean vehicles. Choose from sedans, SUVs, and premium cars for one-way or round-trip travel. Enjoy smooth travel on Mumbai–Pune Expressway with 24×7 cab availability.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-pune-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Pune Cab | Fast & Affordable Taxi Service | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Pune cab services with Shambhu Cabs. Affordable one-way and round-trip taxis with clean cars, expert drivers, and reliable expressway travel. Available 24×7 for airport transfers, corporate trips, and family travel."
  />

  <meta
    name="keywords"
    content="Mumbai Pune Taxi Service, Mumbai Pune One-Way Cab, Intercity Cab Mumbai Pune, Mumbai to Pune Car Rental, Best Cab Mumbai Pune, Affordable Mumbai Pune Taxi, Mumbai Pune Airport Transfer, Chauffeur Service Mumbai Pune, Sedan Cab Mumbai Pune, SUV Cab Mumbai Pune, Expressway Cab Mumbai Pune, 24×7 Mumbai Pune Cab, Mumbai Pune Outstation Cab, Mumbai Pune Corporate Taxi, Fastest Cab Mumbai Pune, Mumbai to Pune Family Cab, Premium Mumbai Pune Cab, Safe Taxi Mumbai Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopunecabs;